const BASE_URL = process.env.REACT_APP_BASE_URL

export const OAUTH_REDIRECT_URL = `${BASE_URL}/login/oauth`

const UTM_PARAMETERS = [
  { key: 'utmSource', param: 'utm_source' },
  { key: 'utmCampaign', param: 'utm_campaign' },
  { key: 'utmMedium', param: 'utm_medium' },
  { key: 'utmTerm', param: 'utm_term' },
  { key: 'utmContent', param: 'utm_content' },
  { key: 'utmId', param: 'utm_id' },
]

// AuthenticatedApp also writes redirectUrl for any protected path, so the path has to be checked rather than the key's presence.
const PROGRAM_REGISTRATION_PATH = /^\/landing\/\d+\/class\/\d+/

const isProgramRegistration = () => PROGRAM_REGISTRATION_PATH.test(localStorage.getItem('redirectUrl') || '')

// utm_source is checked first on purpose: redirectUrl is only cleared on a successful sign-in, so a stale one would outrank today's campaign.
const computeOrigin = (searchParams) => {
  if (localStorage.getItem('communityId')) {
    return 'invitation'
  } else if (searchParams.get('utm_source')) {
    return 'campaign'
  } else if (isProgramRegistration()) {
    return 'program_registration'
  }

  return null
}

const extractUtmParams = (searchParams) => (
  Object.fromEntries(UTM_PARAMETERS.map(({ key, param }) => [key, searchParams.get(param)]).filter(([, value]) => value))
)

export const buildOAuthState = (segment = null, communityId = null, origin = null, utmParams = {}) => (
  JSON.stringify({
    ...(segment && { segment }),
    ...(communityId && { communityId }),
    ...(origin && { origin }),
    ...utmParams,
  })
)

export const buildStateFromParams = (segment = null, communityId = null, searchParams = new URLSearchParams()) => {
  const origin = computeOrigin(searchParams)
  const utmParams = extractUtmParams(searchParams)

  return buildOAuthState(segment, communityId, origin, utmParams)
}
